module.exports = __webpack_public_path__ + "img/11-1.f90bfb28.jpg";